import axios from '@/apis/axios';
import { transformCompanyInfoToUpperCase } from '@/transformer/formationCompanyInfoTransformer';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';
import { transformDirectorAndShareholderValuesToUpperCase } from '@/transformer/formationDirectorAndShareholderTransfomer';

class Formation 
{
    static all()
    {
        return axios.get('/api/admin/formations');
    }

    static async getCompanyInformation()
    {
        const response = await axios.get(`/api/admin/formation/company-information`);

        return response.data.data;
    }

    static async updateCompanyInformation(data)
    {
        const response = await axios.post(`/api/admin/formation/company-information`, {
            data: transformCompanyInfoToUpperCase(data)
        });

        return response.data.data;
    }

    // previous
    // static async getUsersList()
    // {
    //     const response = await axios.get(`/api/admin/formation/directors-and-shareholders`);
    //     return response.data.data;
    // }

    // static async updateDirectorsAndShareholders(data)
    // {
    //     const response = await axios.put(`/api/admin/formation/directors-and-shareholders`, {
    //         data: transformDirectorAndShareholderValuesToUpperCase(data)
    //     });

    //     return response.data;
    // }

    // region shareholder
    static async requiredPOACount()
    {
        const response = await axios.get(`/api/admin/formation/shareholders/require-poa-count`);
        return response.data.data;
    }

    static async getShareholders()
    {
        const response = await axios.get(`/api/admin/formation/shareholders`);
        return response.data.data;
    }

    static async updateShareholders(data)
    {
        const response = await axios.put(`/api/admin/formation/shareholders`, {
            data: transformDirectorAndShareholderValuesToUpperCase(data)
        });

        return response.data;
    }
    // end region shareholder

    // region director
    static async getDirectors()
    {
        const response = await axios.get(`/api/admin/formation/directors`);
        return response.data.data;
    }

    static async updateDirectors(data)
    {
        const response = await axios.put(`/api/admin/formation/directors`, {
            data: transformDirectorAndShareholderValuesToUpperCase(data)
        });

        return response.data;
    }
    // end region director

    static async getDataForBeneficialOwner()
    {
        const response = await axios.get('api/admin/formation/beneficial-owner/getBeneficialOwners');
        return response.data.data;
    }
    
    static async storeBeneficialOwners(data) 
    {
        const response = await axios.post('api/admin/formation/beneficial-owner', transformObjectValuesToUpperCase(data));
        return response;
    }

    static async getDataForRegistrableController()
    {
        const response = await axios.get('api/admin/formation/registrable-controllers/getRegistrableControllers');
        return response.data.data;
    }
    
    static async storeRegistrableControllers(data)
    {
        const response = await axios.post('api/admin/formation/registrable-controllers', transformObjectValuesToUpperCase(data));
        return response;
    }

    static async checkStatusAndRemark(companyId)
    {
        const response = await axios.get(`api/admin/formation/checkStatusAndRemark/${companyId}`);
        return response.data;
    }
}

export default Formation;